import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { Suspense } from 'react'
import Loader from './Loader.jsx'
import { Leva } from 'leva'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<>
    <Leva collapsed />
    <Canvas
        shadows
        orthographic
        camera={ {
            // fov: 45,
            zoom: 80,
            near: 0.1,
            far: 200,
            position: [ 5, 5, 5 ]
        } }
    >
        <Suspense fallback={null}>
            <Experience />
        </Suspense>
    </Canvas>

    <Loader />
    </>
)